import { useRef } from 'react';
import { useButton } from '@react-aria/button';
import I18n from 'I18n';
import styled, { css } from 'styled-components';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import { OBSIDIAN, NEUTRAL_400, NEUTRAL_100 } from 'visitor-ui-component-library/constants/WidgetColors';
import { MIN_LAUNCHER_WIDTH } from '../constants/launcherDimensions';
import { jsx as _jsx } from "react/jsx-runtime";
export const bubbleBaseStyles = css(["min-width:", "px;max-width:", "px;width:100%;display:flex;align-items:center;justify-content:center;box-sizing:border-box;padding:16px;background:", ";border:1px solid ", ";border-radius:8px;font-size:14px;line-height:24px;color:", ";"], MIN_LAUNCHER_WIDTH, ({
  isMobile
}) => isMobile ? 344 : 384, NEUTRAL_100, NEUTRAL_400, OBSIDIAN);
export const textBaseStyles = css(["width:max-content;word-break:break-word;max-width:100%;"]);
const Bubble = styled.div.withConfig({
  displayName: "WelcomeMessage__Bubble",
  componentId: "mgvbgw-0"
})(["", " min-height:72px;"], bubbleBaseStyles);
const Text = styled.p.withConfig({
  displayName: "WelcomeMessage__Text",
  componentId: "mgvbgw-1"
})(["", ""], textBaseStyles);
export const WelcomeMessage = ({
  onClick,
  initialMessage,
  isMobile
}) => {
  const ref = useRef(null);
  const {
    buttonProps
  } = useButton({
    onPress: onClick,
    elementType: 'div'
  }, ref);
  return /*#__PURE__*/_jsx(Bubble, Object.assign({}, buttonProps, {
    "aria-label": I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.open'),
    "aria-haspopup": "dialog",
    ref: ref,
    isMobile: isMobile,
    children: /*#__PURE__*/_jsx(Text, {
      id: "welcome-message",
      "data-test-id": "initial-message-text",
      dangerouslySetInnerHTML: {
        __html: formatHtml(initialMessage || '')
      }
    })
  }));
};
WelcomeMessage.displayName = 'WelcomeMessage';
export default WelcomeMessage;